import { useState, useEffect } from "react";
import {
  errorMapping,
  makeRequest,
  resetStringStates,
} from "../../../assets/functions_helper";
import {
  Box,
  IconButton,
  Typography,
  Breadcrumbs,
  Link,
  Snackbar,
} from "@mui/material";
import { CloseButton, SendButton } from "../../../components/buttons";
import {
  CustomDialog,
  CustomDialogActions,
  CustomDialogContent,
  CustomDialogTitle,
} from "../../../components/customDialog";
import SectionsMenuBuild from "./menu_components/sections_menu_build";
import CreateMenu from "./menu_components/create_menu";
import CreateSection from "./menu_components/create_section";
import AddIcon from "@mui/icons-material/Add";
import ProductsMenuBuild from "./menu_components/products_menu_build";
import ProductSelectionDialog from "./menu_components/product_selection";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import PreviewMenu from "./menu_components/preview_menu";
import { useNavigate } from "react-router-dom";
import MenuList from "./menu_components/list_menu";
import ButtonBack from "./menu_components/button_back";
import PromotionalBannerSettings from "./menu_components/promotional_banner_settings";

function MenuRestaurant({ restaurantId }) {
  // Estado general del componente
  const [listOfMenus, setListOfMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openMenuDialog, setOpenMenuDialog] = useState(false);
  const [openSectionDialog, setOpenSectionDialog] = useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  // Estados relacionados con la creación de menús y secciones
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [nameSection, setNameSection] = useState("");

  const [sectionMenu, setSectionMenu] = useState(false);
  const [sectionProducts, setSectionProducts] = useState(false);
  const [products, setProducts] = useState([]);
  const [loadingSectionMenu, setLoadingSectionMenu] = useState(false);
  const [sections, setSections] = useState([]);
  const [menuId, setMenuId] = useState(0);
  const [hasChanges, setHasChanges] = useState(false);
  const [openWarningDialog, setOpenWarningDialog] = useState(false);
  const [menuInfoComplete, setMenuInfoComplete] = useState(false);
  const [section, setSection] = useState({});

  const [nameOfMenu, setNameOfMenu] = useState("");
  const [itemsWithCorrectOrderValue, setItemsWithCorrectOrderValue] = useState(
    []
  );
  const [menuStates, setMenuStates] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [imageSection, setImageSection] = useState(null);
  const [imageIdSection, setImageIdSection] = useState(null);
  // Estado para saber si PreviewMenu tiene cambios sin guardar
  const [previewHasChanges, setPreviewHasChanges] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!restaurantId) return;
    
    makeRequest(
      "GET",
      `menu_manager/view?restaurant_id=${restaurantId}`,
      null,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        console.log(response);

        const items = Array.isArray(response?.items) ? response.items : [];
        setListOfMenus(items);

        const defaultMenu = items.find((menu) => menu.is_default === true);
        if (defaultMenu?.id) {
          setMenuStates({ [defaultMenu.id]: true });
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log("Error al obtener los menús:", error);
        setLoading(false);
      });
  }, [navigate, restaurantId]);

  const createMenu = () => {
    if (!name?.trim() || !description?.trim()) {
      setSnackbarMessage("⚠️ EL NOMBRE Y LA DESCRIPCIÓN SON OBLIGATORIOS");
      setSnackbarOpen(true);
      return;
    }
    setLoading(true);
    makeRequest(
      "POST",
      "menu_manager/create_menu",
      { restaurant_id: restaurantId, name, description },
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        const newMenu = {
          ...response,
          is_active: false,
          is_default: false,
        };
        setListOfMenus([...listOfMenus, newMenu]);
        setOpenMenuDialog(false);
        setLoading(false);
        handleClearAllMenus();
      })
      .catch((error) => {
        for (const err in errorMapping) {
          if (err.includes(error["error_code"])) {
            setSnackbarMessage(errorMapping[err]);
            setSnackbarOpen(true);
            setLoading(false);
            return;
          }
        }
      });
  };

  const showMenu = (menu, isEditMenu) => {
    setLoadingSectionMenu(true);
    makeRequest(
      "GET",
      `menu_manager/view/${menu.id}`,
      {},
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        console.log("Respuesta del Backend:", response);

        const sectionsWithStyles = (response.sections || []).map((section) => {
          const currentStyles = section.styles || {};
          const normalizedStyles = {
            ...currentStyles,
            buttons_color: currentStyles.buttons_color || section.button_color_cards || null,
            product_background_color: currentStyles.product_background_color || section.background_color_cards || null,
            product_text_color: currentStyles.product_text_color || section.text_color_cards || null,
            product_border_color: currentStyles.product_border_color || section.border_color_cards || "transparent"
          };
          return {
            ...section,
            styles: normalizedStyles
          };
        });

        const fullMenuData = {
          ...response,
          sections: sectionsWithStyles
        };

        setMenuInfoComplete(fullMenuData);
        setSections(sectionsWithStyles);
        setMenuId(menu.id);
        setNameOfMenu(response.name);

        if (isEditMenu) {
          console.log("Menu preparado para edición:", fullMenuData);
          setSelectedMenu(fullMenuData);
        } else {
          setSectionMenu(true);
        }

        setLoadingSectionMenu(false);
      })
      .catch((error) => {
        console.log("Error al obtener las secciones del menú:", error);
        setLoadingSectionMenu(false);
      });
  };

  const handleSubmitCreateBackgroundImage = (nameSection) => {
    const formData = new FormData();
    formData.append("background_image", imageSection);
    formData.append("restaurant_id", restaurantId);

    makeRequest(
      "POST",
      "menu_manager/create_background_image/",
      formData,
      "multipart/form-data",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      null,
      null,
      () => {
        navigate("/login");
      }
    )
      .then((res) => {
        console.log(res);
        createSection(nameSection, res.image_url);
      })
      .catch(() => {
        console.log("error");
      });
  };

  const redirectionerSections = (name) => {
    let isChargingImage = false;

    if (isChargingImage) {
      handleSubmitCreateBackgroundImage(name);
    } else {
      createSection(name, imageSection);
    }
  };

  const createSection = (name, image_url) => {
    const sectionCreate = [
      ...sections,
      {
        name,
        order: sections.length + 1,
        products: [],
        section_type: "default",
        background_image_url: image_url,
        background_image_id: imageIdSection
      },
    ];
    const menuCompleted = {
      sections: sectionCreate,
      is_active: menuInfoComplete.is_active,
      is_default: menuInfoComplete.is_default,
      restaurant_id: restaurantId,
      menu_id: menuId,
      schedule: menuInfoComplete.schedule,
      menu_type: "default",
      background_image_url:
        "https://plus.unsplash.com/premium_photo-1661883237884-263e8de8869b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    };
    console.log(menuCompleted);
    setMenuInfoComplete(menuCompleted);
    makeRequest(
      "POST",
      "menu_manager/edit_menu",
      menuCompleted,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        setSections(sectionCreate);
        setOpenSectionDialog(false);
        setImageSection(null);
        setNameSection("");
      })
      .catch((error) => {
        console.log("Error al crear la sección:", error);
      });
  };

  const showProducts = (section) => {
    console.log("Mostrar productos de la sección:", section);

    if ("products" in section) {
      setProducts(section.products);
    } else {
      setProducts([]);
    }
    setSection(section);
    setSectionProducts(true);
  };

  const addProduct = (selectedProduct) => {
    const newProduct = {
      description: selectedProduct.description || "Descripción no disponible",
      product_id: selectedProduct.id,
      image_url: selectedProduct.image_url,
      price: selectedProduct.price || 0,
      discounted_price: selectedProduct.discounted_price || 0,
      order: products.length,
      pos_id: selectedProduct.pos_id || "sin_pos_id",
      name: selectedProduct.name || "Producto sin nombre",
      is_complex: selectedProduct.is_complex || false,
      detail_variants: selectedProduct.detail_variants || [],
    };

    const productsUpdated = [...products, newProduct];

    setProducts(productsUpdated);
    setHasChanges(true);
    setItemsWithCorrectOrderValue(productsUpdated);
    console.log(productsUpdated);
  };

  // --- NUEVA FUNCIÓN: Eliminar sección ---
  const handleDeleteSection = (sectionId) => {
    // Filtramos la sección a eliminar
    const updatedSections = sections.filter(sec => sec.id !== sectionId && sec.order !== sectionId); // Nota: puede ser por id o por índice, depende de cómo se pase
    // Reordenamos las secciones restantes
    const reorderedSections = updatedSections.map((sec, index) => ({
      ...sec,
      order: index + 1
    }));
    setSections(reorderedSections);
    setHasChanges(true);
    // Actualizamos itemsWithCorrectOrderValue para que el guardado use el orden correcto
    setItemsWithCorrectOrderValue(reorderedSections);
  };

  // --- NUEVA FUNCIÓN: Eliminar producto ---
  const handleDeleteProduct = (productId) => {
    // Filtramos el producto a eliminar
    const updatedProducts = products.filter(prod => prod.product_id !== productId && prod.id !== productId);
    // Reordenamos los productos restantes
    const reorderedProducts = updatedProducts.map((prod, index) => ({
      ...prod,
      order: index + 1
    }));
    setProducts(reorderedProducts);
    setHasChanges(true);
    setItemsWithCorrectOrderValue(reorderedProducts);
  };

  const saveChanges = (isSections) => {
    let updatedMenuInfo = {};
    let updatedSections = [];
    if (isSections) {
      // Guardando cambios en secciones (orden, eliminación, etc.)
      updatedSections = itemsWithCorrectOrderValue;
    } else {
      // Guardando cambios en productos de la sección actual
      console.log(menuInfoComplete);
      updatedSections = menuInfoComplete.sections.map((sec) => {
        if (sec.order === section.order) {
          return {
            ...sec,
            products: itemsWithCorrectOrderValue,
          };
        }
        return sec;
      });
    }
    console.log(updatedSections);
    updatedMenuInfo = {
      ...menuInfoComplete,
      sections: updatedSections,
      menu_id: menuInfoComplete.id
        ? menuInfoComplete.id
        : menuInfoComplete.menu_id,
      schedule: menuInfoComplete.schedule,
      menu_type: "default",
      background_image_url:
        "https://plus.unsplash.com/premium_photo-1661883237884-263e8de8869b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    };

    console.log(updatedMenuInfo);

    makeRequest(
      "POST",
      "menu_manager/edit_menu",
      updatedMenuInfo,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => {
        navigate("/login");
      }
    )
      .then((response) => {
        console.log("Sección guardada exitosamente:", response);
        
        // Sincronización estricta del estado maestro local con los cambios
        setMenuInfoComplete((prev) => ({
          ...prev,
          sections: updatedSections,
        }));
        
        setSections(updatedSections);
        setHasChanges(false);
        setListOfMenus((prevMenus) =>
          prevMenus.map((menu) =>
            menu.id === updatedMenuInfo.menu_id
              ? { ...menu, ...updatedMenuInfo }
              : menu
          )
        );
      })
      .catch((error) => {
        console.error("Error al guardar la sección:", error);
      });
  };

  // Decide si muestra el warning considerando cambios en secciones/productos O en PreviewMenu
  const hasAnyChanges = hasChanges || previewHasChanges;

  const handleBackButton = () => {
    if (hasAnyChanges) {
      setOpenWarningDialog(true);
    } else {
      setSectionProducts(false);
    }
  };

  const handleWarningClose = (save) => {
    setOpenWarningDialog(false);

    if (save) {
      // Si estamos en PreviewMenu (estilos), el usuario debe guardar manualmente desde ahí
      // ya que no tenemos acceso directo a handleSaveMenu de PreviewMenu.
      // Solo hacemos el saveChanges de secciones/productos si aplica.
      if (!previewHasChanges) {
        saveChanges();
      }
      // Si tenía previewHasChanges, simplemente cerramos el warning — el usuario tendrá que
      // usar el botón "Guardar cambios" visible en PreviewMenu antes de navegar.
    } else {
      // Descartar cambios
      if (previewHasChanges) {
        // Venía del PreviewMenu → volver al listado de menús
        setSelectedMenu(null);
        setPreviewHasChanges(false);
        setHasChanges(false);
      } else if (sectionProducts === true && sectionMenu === true) {
        setSectionProducts(false);
        setHasChanges(false);
      } else {
        setSectionMenu(false);
        setHasChanges(false);
      }
    }
  };

  const handleUpdatePromotionalBanner = async (imageId, imageUrl) => {
    const updatedMenuInfo = {
      ...menuInfoComplete,
      promotional_banner_image_id: imageId,
      promotional_banner_image_url: imageUrl,
      menu_id: menuInfoComplete.id || menuInfoComplete.menu_id,
      schedule: menuInfoComplete.schedule,
      menu_type: "default",
      background_image_url:
        "https://plus.unsplash.com/premium_photo-1661883237884-263e8de8869b?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    };

    setMenuInfoComplete(updatedMenuInfo);

    try {
      const response = await makeRequest(
        "POST",
        "menu_manager/edit_menu",
        updatedMenuInfo,
        "application/json",
        localStorage.getItem("token"),
        localStorage.getItem("tokenType"),
        () => navigate("/login")
      );
      console.log("Banner actualizado exitosamente:", response);
      setListOfMenus((prevMenus) =>
        prevMenus.map((menu) =>
          menu.id === updatedMenuInfo.menu_id
            ? { ...menu, ...updatedMenuInfo }
            : menu
        )
      );
    } catch (error) {
      console.error("Error al actualizar banner:", error);
      throw error;
    }
  };

  const handleSwitchDefaultMenu = async (
    menuId,
    newState,
    isActivate,
    state
  ) => {
    const previousMenus = [...listOfMenus]; // Copia del estado original
    const previousState = menuStates;
    console.log(state);
    try {
      if (isActivate) {
        // Actualización optimista del estado local
        const updatedMenus = listOfMenus.map((menu) =>
          menu.id === menuId ? { ...menu, is_active: state } : menu
        );

        // Actualiza listOfMenus con el nuevo estado
        setListOfMenus(updatedMenus);
      } else {
        // Lógica original para el menú predeterminado
        makeRequest(
          "POST",
          `menu_manager/update_default?menu_id=${menuId}`,
          {},
          "application/json",
          localStorage.getItem("token"),
          localStorage.getItem("tokenType")
        )
          .then(() => {
            if (newState) setMenuStates({ [menuId]: true });
          })
          .catch(() => {
            setMenuStates(previousState);
          });
      }
    } catch (error) {
      console.error("Error:", error);
      // Revertir cambios en caso de error
      if (isActivate) {
        setListOfMenus(previousMenus);
      } else {
        setMenuStates(previousState);
      }
    }
  };

  const handleDelete = async (selectedMenuId) => {
    try {
      await makeRequest(
        "DELETE",
        "menu_manager/delete_menu",
        [selectedMenuId.toString()],
        "application/json",
        localStorage.getItem("token"),
        localStorage.getItem("tokenType")
      );

      const updatedMenus = listOfMenus.filter(
        (menu) => menu.id !== selectedMenuId
      );
      setListOfMenus(updatedMenus);
    } catch (error) {
      console.error("Error eliminando menú:", error);
    }
  };

  const handleClearAllMenus = () => {
    resetStringStates(setName, setDescription);
  };

  // Editar nombre e imagen de una sección existente
  const handleEditSection = (section, newName, newImageUrl, newImageId) => {
    const updatedSections = sections.map((sec) => {
      // Comparar por id si existe, si no por order
      const isSame = sec.id ? sec.id === section.id : sec.order === section.order;
      if (isSame) {
        return {
          ...sec,
          name: newName,
          background_image_url: newImageUrl || sec.background_image_url,
          background_image_id: newImageId || sec.background_image_id,
        };
      }
      return sec;
    });
    setSections(updatedSections);
    setItemsWithCorrectOrderValue(updatedSections);
    // Guardar inmediatamente en el backend
    const updatedMenuInfo = {
      ...menuInfoComplete,
      sections: updatedSections,
      menu_id: menuInfoComplete.id || menuInfoComplete.menu_id,
      schedule: menuInfoComplete.schedule,
      menu_type: "default",
      background_image_url:
        menuInfoComplete.background_image_url ||
        "https://plus.unsplash.com/premium_photo-1661883237884-263e8de8869b?fm=jpg&q=60&w=3000",
    };
    setMenuInfoComplete(updatedMenuInfo);
    makeRequest(
      "POST",
      "menu_manager/edit_menu",
      updatedMenuInfo,
      "application/json",
      localStorage.getItem("token"),
      localStorage.getItem("tokenType"),
      () => navigate("/login")
    )
      .then(() => {
        setSnackbarMessage("✅ Sección actualizada exitosamente");
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error("Error al editar la sección:", error);
        setSnackbarMessage("❌ Error al actualizar la sección");
        setSnackbarOpen(true);
      });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <>
      <>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            padding: 2,
            "& .MuiBreadcrumbs-li": {
              color: "#000000 !important",
            },
            "& .MuiBreadcrumbs-separator": {
              color: "#000000 !important",
            },
            "& .MuiTypography-root": {
              color: "#000000 !important",
              fontWeight: 500
            }
          }}
        >
          <Link
            underline="hover"
            sx={{
              color: "#000000 !important",
              cursor: 'pointer'
            }}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (hasAnyChanges) {
                handleBackButton();
              } else {
                // Al hacer clic en "Menús", reseteamos todos los estados de navegación profunda
                setSectionMenu(false);
                setSectionProducts(false);
                setSelectedMenu(null); // Esto quita la vista de edición de estilos/preview
                setPreviewHasChanges(false);
              }
            }}
          >
            Menús
          </Link>

          {/* Breadcrumb para Secciones O para Edición de Estilos */}
          {(sectionMenu || selectedMenu !== null) && (
            <Link
              underline="hover"
              sx={{
                color: sectionProducts ? "#000000 !important" : "inherit",
                cursor: 'pointer'
              }}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                if (hasAnyChanges) {
                  handleBackButton();
                } else {
                  // Si estamos en productos o edición, volvemos a la vista de Secciones
                  setSectionMenu(true);
                  setSectionProducts(false);
                  setSelectedMenu(null);
                  setPreviewHasChanges(false);
                }
              }}
            >
              {selectedMenu !== null
                ? `Editando Estilos: ${nameOfMenu}`
                : `Secciones de ${nameOfMenu}`}
            </Link>
          )}

          {sectionProducts && (
            <Typography sx={{ color: "#000000 !important" }}>
              Productos {section.name}
            </Typography>
          )}
        </Breadcrumbs>
      </>
      {sectionProducts ? ( //PRODUCTS LIST
        <>
          <Box
            sx={{
              display: "flex",
              gap: 4,
              padding: "20px",
            }}
          >
            <ButtonBack
              page={setSectionProducts}
              hasChanges={hasChanges}
              onBackConfirm={handleBackButton}
            />
            <SendButton
              onClick={() => setOpenProductDialog(true)}
              sx={{ maxWidth: "200px" }}
            >
              Agregar Producto
            </SendButton>
            {hasChanges && ( // Condicional para mostrar el botón de guardar
              <SendButton
                onClick={() => saveChanges(false)}
                sx={{ maxWidth: "200px" }}
              >
                Guardar Cambios
              </SendButton>
            )}
          </Box>
          <ProductsMenuBuild
            items={products}
            onClickProducts={() => { }}
            setHasChanges={setHasChanges}
            setItemsWithCorrectOrderValue={setItemsWithCorrectOrderValue}
            onDeleteProduct={handleDeleteProduct} // Pasamos la función de eliminar
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: 4,
              width: "100%",
            }}
          >
            <IconButton
              onClick={() => setOpenProductDialog(true)}
              sx={{
                clipPath: "circle(50% at 50% 50%)",
                background:
                  "#ff3b3b",
                "&:hover": {
                  background: "#ff0000ff"
                }
              }}
            >
              <AddIcon />
            </IconButton>
          </Box>
          {/* Agregar nuevo producto a la seccion*/}
          <ProductSelectionDialog
            open={openProductDialog}
            handleClose={() => setOpenProductDialog(false)}
            restaurantId={restaurantId}
            onAddProduct={addProduct}
          />
        </>
      ) : sectionMenu ? ( //SECTIONS LIST
        <>
          {loadingSectionMenu ? (
            <Box sx={{ height: "100vh" }} />
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  gap: 4,
                  padding: "20px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <RestaurantMenuIcon sx={{ color: "black", fontSize: 28 }} />{" "}
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: 24,
                      fontWeight: "400",
                      wordWrap: "break-word",
                      width: "70%",
                      "@media (max-width:950px)": {
                        width: "100%",
                        textAlign: "center",
                      },
                    }}
                  >
                    Secciones del menú {nameOfMenu}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 4,
                  padding: "20px",
                }}
              >
                <ButtonBack
                  page={setSectionMenu}
                  hasChanges={hasChanges}
                  onBackConfirm={handleBackButton}
                />
                <SendButton
                  onClick={() => setOpenSectionDialog(true)}
                  sx={{ maxWidth: "200px" }}
                >
                  Crear Nueva Sección
                </SendButton>
                {hasChanges && (
                  <SendButton
                    onClick={() => saveChanges(true)}
                    sx={{ maxWidth: "200px" }}
                  >
                    Guardar Cambios
                  </SendButton>
                )}
              </Box>

              {/* Ajustes de Banner Promocional Global para el Menú */}
              <PromotionalBannerSettings
                restaurantId={restaurantId}
                currentBannerUrl={menuInfoComplete?.promotional_banner_image_url}
                onUpdateBanner={handleUpdatePromotionalBanner}
              />

              <SectionsMenuBuild
                items={sections}
                onClickProducts={(id) => {
                  showProducts(id);
                }}
                setHasChanges={setHasChanges}
                setItemsWithCorrectOrderValue={setItemsWithCorrectOrderValue}
                onDeleteSection={handleDeleteSection}
                onEditSection={handleEditSection}
              />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 4,
                  width: "100%",
                }}
              >
                <IconButton
                  onClick={() => setOpenSectionDialog(true)}
                  sx={{
                    clipPath: "circle(50% at 50% 50%)",
                    background:
                      "#ff3b3b",
                    "&:hover": {
                      background: "#ff0000ff"
                    }
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            </>
          )}
        </>
      ) : (
        //MENUS LIST
        <>
          {loading ? (
            <Box sx={{ height: "100vh" }} />
          ) : selectedMenu !== null ? (
            <PreviewMenu
              restaurantId={restaurantId}
              menuData={selectedMenu.sections}
              mobilePreview={true}
              setMenuInfoComplete={setMenuInfoComplete}
              menuInfoComplete={menuInfoComplete}
              onDirtyChange={(dirty) => setPreviewHasChanges(dirty)}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                padding: "20px",
                flexDirection: "column",
              }}
            >
              <SendButton
                onClick={() => setOpenMenuDialog(true)}
                sx={{ maxWidth: "200px", marginBottom: "20px" }}
              >
                Crear Nuevo Menú
              </SendButton>
              <MenuList
                listOfMenus={listOfMenus}
                showMenu={showMenu}
                menuStates={menuStates}
                handleSwitchDefaultMenu={handleSwitchDefaultMenu}
                handleDelete={handleDelete}
                setSelectedMenu={setSelectedMenu}
                restaurantId={restaurantId}
              />
            </Box>
          )}
        </>
      )}

      {/* Dialogo para crear un nuevo menú */}
      <CustomDialog
        open={openMenuDialog}
        onClose={() => {
          setOpenMenuDialog(false);
          handleClearAllMenus(); // Siempre limpiar al cerrar, ya sea por X o por botón
        }}
      >
        <CustomDialogTitle>Crear Menú</CustomDialogTitle>
        <CustomDialogContent>
          <CreateMenu
            name={name}
            description={description}
            setName={setName}
            setDescription={setDescription}
          />
        </CustomDialogContent>
        <CustomDialogActions>
          <CloseButton
            onClick={() => {
              setOpenMenuDialog(false);
              handleClearAllMenus();
            }}
            sx={{
              backgroundColor: "#E0E0E0",
              color: "#424242",
              "&:hover": {
                backgroundColor: "#D5D5D5",
              }
            }}
          >
            Cerrar
          </CloseButton>
          <SendButton onClick={createMenu}>Crear</SendButton>
        </CustomDialogActions>
      </CustomDialog>

      {/* Dialogo para crear una nueva sección */}
      <CustomDialog
        open={openSectionDialog}
        onClose={() => {
          setOpenSectionDialog(false);
          setImageSection(null);
          setNameSection("");
        }}
      >
        <CustomDialogTitle>Crear Nueva Sección</CustomDialogTitle>
        <CustomDialogContent>
          <CreateSection
            nameSection={nameSection}
            setNameSection={setNameSection}
            setImageSection={setImageSection}
            restaurantId={restaurantId}
            setImageIdSection={setImageIdSection}
          />
        </CustomDialogContent>
        <CustomDialogActions>
          <CloseButton
            onClick={() => {
              setOpenSectionDialog(false);
              setImageSection(null);
              setNameSection("");
            }}
            sx={{
              backgroundColor: "#E0E0E0",
              color: "#424242",
              "&:hover": {
                backgroundColor: "#D5D5D5",
              }
            }}
          >
            Cerrar
          </CloseButton>
          <SendButton
            onClick={() => {
              redirectionerSections(nameSection);
            }}
          >
            Crear
          </SendButton>
        </CustomDialogActions>
      </CustomDialog>
      {/* Diálogo de advertencia cuando hay cambios no guardados */}
      <CustomDialog
        open={openWarningDialog}
        onClose={() => setOpenWarningDialog(false)}
      >
        <CustomDialogTitle>Advertencia</CustomDialogTitle>
        <CustomDialogContent>
          <Typography variant="body1">
            Tienes cambios no guardados. ¿Deseas guardar antes de volver?
          </Typography>
        </CustomDialogContent>
        <CustomDialogActions>
          <SendButton onClick={() => handleWarningClose(true)}>
            Guardar
          </SendButton>
          <CloseButton onClick={() => handleWarningClose(false)}>
            No guardar
          </CloseButton>
        </CustomDialogActions>
      </CustomDialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </>
  );
}

export default MenuRestaurant;